import { render, staticRenderFns } from "./PermissionDetail.vue?vue&type=template&id=39ea6a6e&scoped=true"
import script from "./PermissionDetail.vue?vue&type=script&lang=js"
export * from "./PermissionDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39ea6a6e",
  null
  
)

export default component.exports